import getBookingService from '../services/getBookingMeetingType';
import type GetBookingServiceResponseMessage from 'owa-service/lib/contract/GetBookingServiceResponseMessage';
import setMeetingType from '../actions/setMeetingType';
import setGetServicesState from '../actions/setGetMeetingTypesState';
import type ServicesRequestStatus from '../store/schema/ServicesRequestStatus';
import { trace } from 'owa-trace';
import correctFollowUpTime from '../utils/correctFollowUpTime';
import { orchestrator } from 'satcheljs';
import { getBookingServiceAction } from '../actions/getBookingServiceAction';
import { logUsage } from 'owa-analytics';
import store from '../store/Store';
import { convertInboxRemindersToGql } from 'convert-calendar-item';
import { setMeetingTypeInboxReminders } from '../actions/setInboxReminders';

/* eslint-disable-next-line owa-custom-rules/forbid-orchestrator-in-same-package -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE!
 *	> Do not register an orchestrator with an action that is defined in the same package */
orchestrator(getBookingServiceAction, async actionMessage => {
    try {
        const { meetingTypeId } = actionMessage;
        const getBookingServiceMessage: GetBookingServiceResponseMessage | null =
            await getBookingService(meetingTypeId);

        if (getBookingServiceMessage?.BookingService?.ServiceId) {
            const BookingService = correctFollowUpTime(getBookingServiceMessage?.BookingService);
            BookingService && setMeetingType(BookingService);
            // Saving the inbox reminders in the store as it isn't already present
            store.inboxReminders = BookingService?.InboxReminders ?? [];
            // Setting the inboxReminders in the store to display it on service duplication
            setMeetingTypeInboxReminders(
                convertInboxRemindersToGql(BookingService?.InboxReminders ?? [])
            );
        }
        setGetServicesState(2);
        logUsage('GetBookingServiceSuccess');
    } catch (e) {
        trace.warn(e.message || 'getBookingService failed');
        setGetServicesState(4);
        logUsage('GetBookingServiceFailed');
    }
});
